/* ============================================
   RUSHES Clothing — Theme JS (V1.0 product-led)
   ============================================ */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initializeProductPreviews(root) {
    root.querySelectorAll('.product-card').forEach(function (card) {
      var button = card.querySelector('.product-card__flip');
      var back = card.querySelector('.product-card__hover');
      var front = card.querySelector('.product-card__primary');
      var media = card.querySelector('.product-card__media');
      if (!button || !back || card.dataset.previewInitialized) return;
      card.dataset.previewInitialized = 'true';
      card.classList.add('is-preview-ready');
      var ready = false;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      function showBack(visible) {
        visible = Boolean(visible && ready);
        card.classList.toggle('is-back-visible', visible);
        button.setAttribute('aria-pressed', String(visible));
        button.setAttribute('aria-label', visible ? button.dataset.frontLabel : button.dataset.backLabel);
        button.textContent = visible ? button.dataset.frontText : button.dataset.backText;
        front.setAttribute('aria-hidden', String(visible));
        back.setAttribute('aria-hidden', String(!visible));
      }

      function imageReady() {
        ready = back.naturalWidth > 0;
        button.hidden = !ready;
        if (ready && canHover.matches && media.matches(':hover')) showBack(true);
      }

      back.addEventListener('load', imageReady);
      back.addEventListener('error', function () {
        ready = false;
        button.hidden = true;
        showBack(false);
      });
      if (back.complete) imageReady();
      button.addEventListener('click', function () {
        showBack(!card.classList.contains('is-back-visible'));
      });
      media.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse' && canHover.matches) {
          back.loading = 'eager';
          showBack(true);
        }
      });
      media.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'mouse') showBack(false);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') showBack(false);
      });
    });
  }
  initializeProductPreviews(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeProductPreviews(event.target);
  });

  var collectionMenu = document.getElementById('mobile-nav');
  var menuTriggers = document.querySelectorAll('[data-menu-open]');
  var activeMenuTrigger = null;
  if (collectionMenu && typeof collectionMenu.showModal === 'function') {
    menuTriggers.forEach(function (trigger) {
      trigger.hidden = false;
      trigger.addEventListener('click', function () {
        activeMenuTrigger = trigger;
        collectionMenu.showModal();
        document.body.classList.add('menu-is-open');
        menuTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
      });
    });
    function closeMenu() { collectionMenu.close(); }
    collectionMenu.querySelector('[data-menu-close]').addEventListener('click', closeMenu);
    collectionMenu.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', closeMenu); });
    collectionMenu.addEventListener('close', function () {
      document.body.classList.remove('menu-is-open');
      menuTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      if (activeMenuTrigger) activeMenuTrigger.focus({ preventScroll: true });
    });
  }

  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 80) header.classList.add('site-header--scrolled');
      else header.classList.remove('site-header--scrolled');
    }, { passive: true });
  }

  document.querySelectorAll('.qty-control__input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (!form) return;
      clearTimeout(input._submitTimer);
      input._submitTimer = setTimeout(function () { form.submit(); }, 600);
    });
  });

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var style = document.createElement('style');
    style.textContent =
      '.fade-in{opacity:0;transform:translateY(16px);transition:opacity .55s ease,transform .55s ease}' +
      '.fade-in.visible{opacity:1;transform:none}';
    document.head.appendChild(style);

    var targets = document.querySelectorAll(
      '.section-header, .world-door, .email-capture__text, .email-capture__form-wrap'
    );
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });

    targets.forEach(function (el) {
      el.classList.add('fade-in');
      observer.observe(el);
    });
  }
})();
